// extracted by mini-css-extract-plugin
export default {"Table":"Wishlist_Table__T6-Gk"};